import { GrowthBook } from '@growthbook/growthbook-react'
import { DataLayerEventName } from '../models/enums'
import { rudderAnalytics } from './rudderstack'
import { pushToDataLayer } from './dataLayerEvents'

export const growthbook = new GrowthBook({
  apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
  clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: import.meta.env.DEV,
  trackingCallback: (experiment, result) => {
    const data = {
      experimentId: experiment.key,
      variationId: Number(result.variationId),
    }
    console.log('Growthbook event:', data)

    rudderAnalytics.track(DataLayerEventName.Growthbook, data)
    pushToDataLayer({ event: DataLayerEventName.Growthbook, data })
  },
})
